import { useState, useEffect } from 'react'
import eventBus from '../eventBus/index'
import { IEBTopicData } from '../eventBus/eventBus.types'

const useConfirmService = () => {
  const [active, setActive] = useState(false)
  const [data, setData] = useState<IEBTopicData['confirm-service.request']>({
    title: '',
    description: '',
    buttonType: '' as any,
    confirmText: '',
    isDanger: false,
    onConfirm: null,
  })

  useEffect(() => {
    const unsubscribe = eventBus.sub('confirm-service.request', (ev) => {
      setData((prev) => ({
        ...prev,
        description: ev.description,
        title: ev?.title,
        confirmText: ev.confirmText,
        buttonType: ev.buttonType,
        isDanger: ev.isDanger,
        onConfirm: ev.onConfirm,
      }))
      setActive(true)
      setTimeout(() => setActive(false), 60000) // 60s
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return { data, active, setActive }
}

export default useConfirmService
